import { username } from "../types/types";
import { callApi } from "./api.service";

export const CheckUserName = async (getToken: () => Promise<string | null>) => {
  const endpoints = "/api/username/has";
  return await callApi(endpoints, "GET", true, getToken);
};

export const VerifyUserName = async (
  getToken: () => Promise<string | null>,
  data: username
) => {
  const endpoints = "/api/username/check";
  return await callApi(endpoints, "POST", true, getToken, data);
};

export const SuggestionUserName = async (
  getToken: () => Promise<string | null>,
  data: username
) => {
  const endpoints = "/api/username/suggestions";
  return await callApi(endpoints, "POST", true, getToken, data);
};

export const SaveUserName = async (
  getToken: () => Promise<string | null>,
  data: username
) => {
  const endpoints = "/api/username/save";
  return await callApi(endpoints, "POST", true, getToken, data);
};
